/**
 * Utility functions for styling and theme handling
 */

/**
 * Enforce active menu item styling
 * This function ensures that active menu items maintain their active styling,
 * especially when hovered
 */
export const enforceActiveMenuStyling = () => {
  // Add 'active' class to any menu item that matches the current path
  const currentPath = window.location.pathname;
  const menuItems = document.querySelectorAll('.sidebar-navigation .menu-item');
  
  menuItems.forEach(item => {
    const link = item.querySelector('a');
    if (!link) return;
    
    const href = link.getAttribute('href');
    if (!href) return;
    
    // Check if current path matches or starts with this menu item's path
    const isActive = 
      currentPath === href || 
      (href !== '/' && currentPath.startsWith(href + '/'));
    
    if (isActive) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
    
    // Don't set any inline styles
  });
};

/**
 * Setup mutation observer to watch for DOM changes and enforce styling
 */
export const setupStyleObserver = () => {
  const observer = new MutationObserver(() => {
    // Use class-based styling only
    enforceActiveMenuStyling();
  });
  
  // Start observing the document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  return observer;
};

// Apply initial enforcement
enforceActiveMenuStyling();

// Export default for convenience
export default {
  enforceActiveMenuStyling,
  setupStyleObserver
}; 